import Vue from 'vue'

export async function createClaim ({ commit }, claim) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    const { data } = await Vue.axios({
      method: 'POST',
      url: '/claim',
      data: claim
    })
    return data
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function updateClaim ({ commit }, claim) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })
    await Vue.axios({
      method: 'PUT',
      url: `/claim/${claim.id}`,
      data: claim
    })
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function getClaims ({ commit }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('setClaims', null)
    const { data } = await Vue.axios({
      url: '/claim'
    })
    commit('setClaims', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  }
}

export async function getClaimByPurchase ({ commit }, purchaseID) {
  try {
    commit('shared/setError', false, { root: true })
    commit('setClaim', null)
    const { data } = await Vue.axios({
      method: 'GET',
      url: `/claim-by-purchase/${purchaseID}`
    })
    commit('setClaim', data)
  } catch (error) {
    commit('shared/setError', error, { root: true })
  }
}
